export default __webpack_public_path__ + "assets/icons/iconFrom.67b0f716.svg";